<template>
  <v-container>
    <!--    Heading-->
    <!--    Heading-->
    <v-row>
      <v-col md="4" sm="12" class="primary--text">
        <h4 class="title mb-2">{{ $route.name }}</h4>
        <p style="font-size: .7rem"></p>
      </v-col>

      <v-col md="4" sm="12"></v-col>
    </v-row>

    <v-row class="justify-space-between flex-column flex-md-row">
      <v-col md="6" sm="12">
        <v-text-field
          rounded
          filled
          flat
          placeholder="Search"
          v-model="search"
          append-icon="mdi-magnify"
          class="search"
        ></v-text-field>
      </v-col>
      <v-col md="2" sm="12">
        <download-csv
          class="btn btn-default"
          :data="payments"
          name="payments.csv"
        >
          <v-icon
            medium
            color="dark-gray  darken-2"
            style="padding: 10px; background: lightgray; border-radius:50%; cursor: pointer"
          >
            mdi-export
          </v-icon>
          <span class="ml-2">Download CSV</span>
        </download-csv>
      </v-col>
    </v-row>

    <!--    Page-->
    <v-row>
      <v-col>
        <v-data-table :headers="headers" :items="payments" show-select dense>
          <template v-slot:item.image="{ item }">
            <v-avatar class="ma-2">
              <img :src="item.image" alt="John" />
            </v-avatar>
          </template>
          <template v-slot:item.licence="{ item }">
            <a class="text-decoration-none" :href="item.licence">
              <v-icon color="primary" small class="mr-2">
                mdi-export
              </v-icon>
            </a>
          </template>
          <template v-slot:item.cert="{ item }">
            <a class="text-decoration-none" :href="item.cert">
              <v-icon color="primary" small class="mr-2">
                mdi-export
              </v-icon>
            </a>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Payments",
  data: () => ({
    headers: [
      { text: "", align: "start", value: "image" },
      { text: "Customer", value: "customer" },
      { text: "Transaction Code.", align: "start", value: "Transaction_code" },
      { text: "Transaction Type.", align: "start", value: "Transaction_type" },
      { text: "Amount", value: "amount" },
      { text: "Date", value: "date" }
    ]
  }),

  computed: {
    payments() {
      return this.$store.getters["Dashboard/payments"];
    }
  },

  created() {
    this.$store.dispatch("Dashboard/fetchPayments");
  }
};
</script>

<style scoped>
.compact-form {
  transform: scale(0.675);
  transform-origin: left;
}
</style>
